<div class="search-bar">
  <span class="material-symbols-outlined search-icon">search</span>
  <input
    type="text"
    class="search-input"
    data-testid="search-input"
    [placeholder]="placeholder()"
    [value]="query()"
    (input)="onInput($any($event.target).value)"
  />
  @if (query()) {
    <button type="button" class="clear-btn material-symbols-outlined" (click)="clear()" aria-label="Clear search">
      close
    </button>
  } @else if (shortcutLabel()) {
    <span class="shortcut-chip">{{ shortcutLabel() }}</span>
  }
</div>
